export default "__VITE_ASSET__DSLlk$36__"